import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { createRef, useContext, useEffect, useState } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import axios from 'axios';
import { Container, Label } from './input-sc';
import ErrorMessage from './errorMessage';

const PhoneInput = ({
    errors,
    touched,
    name,
    label,
    phoneCountry,
    setPhoneValid,
    phoneErrorMessage,
    labelColor,
    differentBg,
    isFocused,
    ...props
}) => {
    const [focused, setFocused] = useState(false);
    const [flagOpen, setFlagOpen] = useState(false);
    const [defaultCountry, setDefaultCountry] = useState(null);

    const {
        initialValues,
        setFieldValue,
        setFieldTouched,
        values,
        setFieldError,
    } = useFormikContext();

    let value = initialValues[name];
    const phoneRef = createRef();

    useEffect(() => {
        if (value || values[name]) {
            setFocused(true);
        }
    });

    const onFlagUpdate = phoneNumber => {
        setFlagOpen(false);
        if (phoneNumber && phoneNumber[0] !== '+') {
            phoneRef.current?.updateValFromNumber(phoneNumber, true, true);
        }
    };

    const onChange = (valid, phoneNumber, prefix, completeNumber) => {
        setFieldValue(
            name,
            {
                inputNumber: phoneNumber,
                withPrefix: completeNumber,
                __type: 'phone',
            },
            false
        );
        setPhoneValid(valid);
        if (!valid) {
            setFieldError(name, phoneErrorMessage);
        } else {
            setFieldError(name, null);
        }
    };

    useEffect(() => {
        axios
            .get('https://freegeoip.app/json/')
            .then(e =>
                setDefaultCountry(e.data.country_code.toLowerCase() || null)
            )
            .catch(e => {
                console.error(e);
                setDefaultCountry(null);
            });
    }, [name]);

    return (
        <div>
            <Container
                onFocus={() => setFocused(true)}
                focused={focused}
                style={{
                    opacity: flagOpen ? '1' : '0.99',
                    paddingLeft: '10px',
                }}
            >
                <PhoneLabel
                    labelColor={labelColor}
                    htmlFor={name + '__id'}
                    onClick={() => setFocused(true)}
                    focused={focused}
                >
                    {label}
                </PhoneLabel>

                <IntlTelInput
                    ref={phoneRef}
                    onPhoneNumberChange={onChange}
                    onFlagClick={() => setFlagOpen(true)}
                    onPhoneNumberBlur={() => setFieldTouched(name, true, false)}
                    onSelectFlag={e => onFlagUpdate(e)}
                    defaultCountry={defaultCountry}
                    format={true}
                    value={values[name]?.inputNumber}
                    autoPlaceholder={false}
                    preferredCountries={['cz', 'sk', 'es', 'ro', 'it']}
                    id={name + '__id'}
                    name={name}
                    autoComplete="on"
                    autoFocus={isFocused}
                />
            </Container>

            <ErrorMessage show={errors[name]}>{errors[name]}</ErrorMessage>
        </div>
    );
};

export default PhoneInput;

const PhoneLabel = styled(Label)`
    z-index: 99999;
    pointer-events: none;
    margin-left: ${({ focused }) => (focused ? '0' : '55px')};
`;
